import { FormattedMessage } from 'react-intl';
import { boolean, object, string, ref, InferType } from 'yup';

import { withPasswordValidation } from '@/shared/config';

import { FinishRegistrationMethod } from './constants';

export const confirmPasswordFormSchema = object({
  password: withPasswordValidation(string().required()),
  confirmPassword: string()
    .oneOf([ref('password')], () => (
      <FormattedMessage
        id="signUp.passwordsMustMatch"
        defaultMessage="Passwords must match"
      />
    ))
    .required(),
  marketingCommunicationConsent: boolean(),
});

export const signUpViaSalesmanFormSchema = object({
  password: withPasswordValidation(string().required()),
  confirmPassword: string()
    .oneOf([ref('password')], () => (
      <FormattedMessage
        id="signUp.passwordsMustMatch"
        defaultMessage="Passwords must match"
      />
    ))
    .required(),
});

export const finishRegistrationFormSchema = {
  [FinishRegistrationMethod.confirmPassword]: confirmPasswordFormSchema,
  [FinishRegistrationMethod.signUpViaSalesman]: signUpViaSalesmanFormSchema,
};

export type FinishRegistrationFormPayload = InferType<
  (typeof finishRegistrationFormSchema)[FinishRegistrationMethod]
>;
